import { ColProps, FormInstance } from 'antd';
import React from 'react';

type RequiredMark =
  | boolean
  | 'optional'
  | ((
      labelNode: React.ReactNode,
      info: {
        required: boolean;
      }
    ) => React.ReactNode);

type FormLabelAlign = 'left' | 'right';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const _ValidateStatuses: readonly [
  'success',
  'warning',
  'error',
  'validating',
  '',
];

type ValidateStatus = (typeof _ValidateStatuses)[number];

type FeedbackIcons = (itemStatus: {
  status: ValidateStatus;
  errors?: React.ReactNode[];
  warnings?: React.ReactNode[];
}) => {
  [key in ValidateStatus]?: React.ReactNode;
};

interface FormContextProps {
  vertical: boolean;
  name?: string;
  colon?: boolean;
  labelAlign?: FormLabelAlign;
  labelWrap?: boolean;
  labelCol?: ColProps;
  wrapperCol?: ColProps;
  requiredMark?: RequiredMark;
  itemRef: (name: (string | number)[]) => (node: React.ReactElement) => void;
  form?: FormInstance;
  feedbackIcons?: FeedbackIcons;
}

export const FormContext = React.createContext<FormContextProps>({} as any);
